export default "__VITE_ASSET__PwMxuto8__"